import React from 'react'
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const Articles = (props) => {
    const { articlesList, searchText, tab } = props;
    const typeHeadSearchEvent = (obj) => {
        HelperAnalyticsEvent.typeHeadSearchEvent(searchText, 'Articles', obj?.name, obj?.url);
    }

    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Articles</div>
            {Object.keys(articlesList).length > 0 &&
                <>
                    <div className="search-product-list">
                        {Object.keys(articlesList).length > 0 && Object.entries(articlesList).map((v, i) => (
                            <React.Fragment key={i}>
                                {
                                    i < 5 &&

                                    <div className="search-product-list-item">
                                        <div className='search-product-list-item-info'>
                                            <div className="documents-date">{v[1].date}</div>
                                            <a onClick={() => typeHeadSearchEvent(v[1])} href={v[1]?.url} className="cursor-pointer">
                                                <div className="search-product-list-info-title">{v[1].name}</div>
                                            </a>
                                            <div className="search-product-list-info-desc">{v[1].shortDescription}</div>
                                        </div>
                                    </div>
                                }
                            </React.Fragment>
                        ))}
                    </div>
                    <a href={HomePage.makeHomeTabsListRouteURL(tab) + "&__c_HomePageContent=ALCT&__c_HomePageContentTabList=ACL&search=" + searchText}
                        className="text-center mt-auto pb-3">
                        <div className="bs5 btn btn-sm btn-primary">VIEW ALL ARTICLE RESULTS</div>
                    </a>
                </>
            }
            {Object.keys(articlesList).length === 0 &&
                <>
                    <NoContent />
                </>
            }
        </>
    )
}

export default Articles